import { FetchUnknownUserTemplatesQuery, FetchUnknownUserTemplatesQueryVariables } from 'es/app/__generated__/global';
import { FETCH_UNKNOWN_USER_TEMPLATES } from 'es/app/views/system/sso-user-templates/graphql/system.fetchUnknownUserTemplates';
import ApolloProvider from 'es/core/net/ApolloProvider';

export async function fetchUnknownUserTemplates() {
    const { data } = await ApolloProvider.system.query<
        FetchUnknownUserTemplatesQuery,
        FetchUnknownUserTemplatesQueryVariables
    >({
        query: FETCH_UNKNOWN_USER_TEMPLATES,
    });

    return data.system.unknownUserTemplates;
}
